// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-common-modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    gap: 5px;
    height: 98%;

    * > div {
        width: 100%;
    }

    [data-action-buttons] {
        align-self: flex-end;

        & > * {
            background-color: var(--outline);

            &:hover {
                background-color: var(--surface-variant-transparency);
                transition: background-color 0.5s ease-in-out color 0.5s ease-in-out;
                cursor: pointer;
            }
        }
    }
}

.img-icons-outside-card {
    display: flex;
}

[data-details-view-image-image] {
    align-items: center;
    position: relative;
    height: 50%;

    & > img,
    & > video {
        max-height: 54vh;
        aspect-ratio: 16/9 auto;
    }

    video {
        width: 90%;
    }
}

.common-details-view-image-info {
    width: 100%;
    height: fit-content;
    max-height: 108px;
    gap: 10px;

    & > p {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin: 0;
    }
}

.title-with-link-container {
    justify-content: space-between;
    margin-block-end: 4px;

    & > * {
        margin: 0;
    }
}

.arrow-zoom-modal {
    --md-icon-button-icon-size: 40px;
    transition: transform 0.2s ease;
    position: absolute;

    &:hover {
        transform: scale(1.3);
    }

    & > md-icon {
        color: var(--slide-arrow-color);
    }
}

.arrow-zoom-modal-left {
    left: 0;
}

.arrow-zoom-modal-right {
    right: 0;
}

.options-download-zoom-modal {
    top: 140px;
    right: -70px;
    left: auto;
}

[data-footer-container] {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    gap: 10px;

    & [data-see-report-button] {
        display: none;
    }
}
`, "",{"version":3,"sources":["webpack://./../components/src/modals/ZoomModalComponent/ZoomModalComponent.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,QAAQ;IACR,WAAW;;IAEX;QACI,WAAW;IACf;;IAEA;QACI,oBAAoB;;QAEpB;YACI,gCAAgC;;YAEhC;gBACI,qDAAqD;gBACrD,oEAAoE;gBACpE,eAAe;YACnB;QACJ;IACJ;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;;IAEX;;QAEI,gBAAgB;QAChB,uBAAuB;IAC3B;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,SAAS;;IAET;QACI,gBAAgB;QAChB,uBAAuB;QACvB,mBAAmB;QACnB,SAAS;IACb;AACJ;;AAEA;IACI,8BAA8B;IAC9B,qBAAqB;;IAErB;QACI,SAAS;IACb;AACJ;;AAEA;IACI,gCAAgC;IAChC,+BAA+B;IAC/B,kBAAkB;;IAElB;QACI,qBAAqB;IACzB;;IAEA;QACI,+BAA+B;IACnC;AACJ;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,aAAa;IACb,WAAW;IACX,yBAAyB;IACzB,SAAS;;IAET;QACI,aAAa;IACjB;AACJ","sourcesContent":[".custom-common-modal {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-between;\n    padding: 10px;\n    gap: 5px;\n    height: 98%;\n\n    * > div {\n        width: 100%;\n    }\n\n    [data-action-buttons] {\n        align-self: flex-end;\n\n        & > * {\n            background-color: var(--outline);\n\n            &:hover {\n                background-color: var(--surface-variant-transparency);\n                transition: background-color 0.5s ease-in-out color 0.5s ease-in-out;\n                cursor: pointer;\n            }\n        }\n    }\n}\n\n.img-icons-outside-card {\n    display: flex;\n}\n\n[data-details-view-image-image] {\n    align-items: center;\n    position: relative;\n    height: 50%;\n\n    & > img,\n    & > video {\n        max-height: 54vh;\n        aspect-ratio: 16/9 auto;\n    }\n\n    video {\n        width: 90%;\n    }\n}\n\n.common-details-view-image-info {\n    width: 100%;\n    height: fit-content;\n    max-height: 108px;\n    gap: 10px;\n\n    & > p {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        margin: 0;\n    }\n}\n\n.title-with-link-container {\n    justify-content: space-between;\n    margin-block-end: 4px;\n\n    & > * {\n        margin: 0;\n    }\n}\n\n.arrow-zoom-modal {\n    --md-icon-button-icon-size: 40px;\n    transition: transform 0.2s ease;\n    position: absolute;\n\n    &:hover {\n        transform: scale(1.3);\n    }\n\n    & > md-icon {\n        color: var(--slide-arrow-color);\n    }\n}\n\n.arrow-zoom-modal-left {\n    left: 0;\n}\n\n.arrow-zoom-modal-right {\n    right: 0;\n}\n\n.options-download-zoom-modal {\n    top: 140px;\n    right: -70px;\n    left: auto;\n}\n\n[data-footer-container] {\n    display: flex;\n    width: 100%;\n    justify-content: flex-end;\n    gap: 10px;\n\n    & [data-see-report-button] {\n        display: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
